var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorRedFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E24545",
    d: "M15 0C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15C29.976 6.726 23.274.024 15 0zm6.188 19.42l-1.768 1.767-4.42-4.42-4.42 4.42-1.768-1.767 4.42-4.42-4.42-4.42 1.768-1.768 4.42 4.42 4.42-4.42 1.767 1.768-4.42 4.42 4.42 4.42z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRedFilled);
export default __webpack_public_path__ + "static/media/error-red-filled.bf287ac8701b48a04f1c25f4f716d7ec.svg";
export { ForwardRef as ReactComponent };